import http, { ResponseData } from './httpService'

export interface MerchantApplyRequest {
  name: string
  idCardNo: string
  phone: string
  smsCode: string
}

export interface MerchantApplyResponse {
  redirectUrl: string
}

export type MerchantCallbackResponse = boolean
export type MerchantCompleteRequest = MerchantApplyRequest
export interface MerchantCompleteResponse {
  redirectUrl: string
}
export type MerchantCompleteCallbackResponse = boolean

export const merchantApply = async (param: MerchantApplyRequest): Promise<MerchantApplyResponse> => {
  const { data } = await http.post<ResponseData<MerchantApplyResponse>>('/fe/merchant/application/faceid', param)
  return data.data
}

export const merchantCallback = async (applicationId: string): Promise<MerchantCallbackResponse> => {
  const { data } = await http.post<ResponseData<MerchantCallbackResponse>>('/fe/merchant/application/faceid/callback', {
    applicationId,
  })
  return data.data
}

export const merchantComplete = async (param: MerchantCompleteRequest): Promise<MerchantCompleteResponse> => {
  const { data } = await http.post<ResponseData<MerchantCompleteResponse>>(
    '/fe/merchant/application/faceid/complete',
    param
  )
  return data.data
}

export const merchantCompleteCallback = async (applicationId: string): Promise<MerchantCompleteCallbackResponse> => {
  const { data } = await http.post<ResponseData<MerchantCompleteCallbackResponse>>(
    '/fe/merchant/application/faceid/complete/callback',
    {
      applicationId,
    }
  )
  return data.data
}
